import { useEffect } from 'react'

import { useSearchContactsSfcQuery } from '../api'

export const ContactsSearchHandler = ({
  query,
  onResults,
  onFetching
}) => {
  const { data, isFetching, isSuccess } = useSearchContactsSfcQuery(query, { skip: !query })

  useEffect(() => {
    if (isSuccess) {
      onResults(data.contacts)
    }
  }, [isSuccess, data, onResults])

  useEffect(() => {
    onFetching(isFetching)
  }, [isFetching, onFetching])

  return null
}
